import Button from "@components/common/Button/Button";
import { Close } from "@mui/icons-material";
import type { ProfileHeaderProps } from "../types";

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ title, onClose }) => {
	return (
		<div className="flex justify-between items-center p-6 pb-4 flex-shrink-0">
			<h2 className="text-3xl font-bold text-gray-900">{title}</h2>
			<Button variant="icon" type="button" onClick={onClose} aria-label="Close">
				<Close className="w-5 h-5 text-gray-500" />
			</Button>
		</div>
	);
};

export default ProfileHeader;
